export default __webpack_public_path__ + "img/birthday.740368c4.svg";